import { EncryptStorage } from "encrypt-storage";

// const encryptStorage = new EncryptStorage(process.env.SECRET_KEY, options);
export const encryptStorage = new EncryptStorage("secret-key-value", {
  prefix: "@darji-point",
  stateManagementUse: true,
  encAlgorithm: "Rabbit",
});
